import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import {
  ActionType,
  Flow,
  useBookingContext,
} from '@common/context/BookingContext';
import useQueryParams from '@common/utils/hooks/useQueryParams';
import { useScopedTranslation } from '@common/utils/hooks/useScopedTranslation';
import { CallbackQuery } from '@typings/api';

import BookingFlow from './BookingFlow';
import { CALLBACK } from './queries';
import ReferralFlow from './ReferralFlow';

export default function MainForm() {
  const { t } = useScopedTranslation();
  const { id: contextId } = useQueryParams();
  const [{ customerDirty, flow }, dispatch] = useBookingContext();

  const { data } = useQuery<CallbackQuery>(CALLBACK, {
    variables: {
      contextId,
    },
    skip: !contextId,
  });

  useEffect(() => {
    dispatch({
      type: ActionType.SET_CALLBACK,
      payload: data?.context?.callback?.enabled === true,
    });
  }, [data, dispatch]);

  return (
    <div
      className={`flex flex-col items-stretch flex-1 relative pb-100 ${
        customerDirty ? 'pointer-events-none' : 'pointer-events-auto'
      }`}
    >
      {flow === Flow.BOOKING && <BookingFlow />}
      {flow === Flow.SELF_SERVICE && <BookingFlow />}
      {flow === Flow.REFERRAL && <ReferralFlow />}
      {flow === Flow.FORCED_REFERRAL && <ReferralFlow isForced />}
      {flow === Flow.BLOCKED && <p>{t('main_form.no_actions_possible')}</p>}
    </div>
  );
}
